import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Drawer, Icon, Link } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";

import { MobileMenuBar } from "@/premium/themedComponents/MenuBar";
import { useEnrollmentContext } from "@/state";
import { enableComparePlansPage } from "@/utils/featureFlags";

import "./MobileMenuBar.scss";

const translationPath = "HEADER_AND_FOOTER";

interface MobileMenuDrawerProps {
  isVisible: boolean;
  setVisible: (visible: boolean) => void;
}

export const MobileMenuDrawer = ({ isVisible, setVisible }: MobileMenuDrawerProps) => {
  const urlLocation = window.location;
  const searchParams = new URLSearchParams(urlLocation.search);
  const clientName = searchParams.get("client");
  const experienceData = useEnrollmentContext();
  const menuItems = experienceData?.menu_items;
  const { t: translate } = useTranslation();

  const onMobileMenuToggle = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <Drawer size="ultra-wide" visible={isVisible}>
      <div style={{ top: "0", left: "0", position: "fixed", width: "100%" }}>
        <MobileMenuBar mobileMenuIcon="x" onMobileMenuToggle={onMobileMenuToggle} />
      </div>
      <Stack className="drawer-links-container" spacing="large">
        <Link className="menu-bar-link" to={{ pathname: "/plans", search: `client=${clientName}` }}>
          {translate(`${translationPath}.plans`)}
        </Link>
        {enableComparePlansPage() && (
          <Link className="menu-bar-link" to={{ pathname: "/compare-plans", search: `client=${clientName}` }}>
            {translate(`${translationPath}.comparePlans`)}
          </Link>
        )}
        {menuItems
          .sort((a, b) => a.display_order - b.display_order)
          .map((item) => (
            <Shelf key={item.id}>
              <Link key={item.id} className="menu-bar-link" to={item.link_url}>
                {item.link_name}
              </Link>
              <Icon name="link-out" />
              <Shelf.Spacer />
            </Shelf>
          ))}
      </Stack>
    </Drawer>
  );
};
